import { Component, OnInit } from '@angular/core';
import { SnackbarService } from '@app/services';
import { CacheService } from '@app/services/cache.service';

@Component({
  selector: 'app-app-update-band',
  templateUrl: './app-update-band.component.html',
  styleUrls: ['./app-update-band.component.scss']
})
export class AppUpdateBandComponent implements OnInit {

  appUpdate: boolean;

  constructor(
    private cacheService: CacheService
  ) { }

  ngOnInit(): void {
    this.cacheService.appUpdateSubject.asObservable().subscribe(() => this.appUpdate = true);
  }

  reloadApp() {
    console.log('=> Reloading for new app version !');

    window.location.reload();
  }
}
